import * as React from "react";
const SvgFiRrSledding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sledding_svg__a)">
      <path
        fill="#062147"
        d="M23.9 21.73a3.887 3.887 0 0 1-5.24 1.877L.566 14.9a1 1 0 0 1 .867-1.8l18.095 8.7a1.894 1.894 0 0 0 2.57-.939 1 1 0 0 1 1.8.865zM5 6h7.566l-3.852 5.062A3 3 0 0 0 11 16h4.38a1.01 1.01 0 0 1 .978.792l.3 1.417a1 1 0 1 0 1.954-.417l-.3-1.418A3.015 3.015 0 0 0 15.383 14H11a.98.98 0 0 1-.907-.579 1.02 1.02 0 0 1 .177-1.108l4.388-5.764 1.131.722a1.19 1.19 0 0 1-.118 1.468l-1.285 1.647a1 1 0 0 0 1.58 1.229l1.275-1.637a3.1 3.1 0 0 0-.127-4.211 1 1 0 0 0-.15-.119l-1.349-.861A5 5 0 0 0 12.927 4H5a1 1 0 0 0 0 2m13.5-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sledding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSledding;
